import React, { useState } from 'react'
import './styles.css'

const emptySessions = [
    "networking",
    "lunch"
]

const MultiDayAgenda = props => {
    const [activeTab, updateActiveTab] = useState(props.activeTab || 0)
    const dates = props.sessions && props.sessions.filter(({ type, date }) => !emptySessions.includes(type) && date)
        .map(({ date }) => date)
    return <section className="tabs">
        {dates && [...new Set(dates)].map((currentDate, index) => {
            // Parse dates according to design
            let suffix = 'th'
            let dateObject = new Date(currentDate)
            let dateModulos = dateObject.getDate() % 10

            suffix = dateModulos === 0 ? 'th' : suffix
            suffix = dateModulos === 1 ? 'st' : suffix
            suffix = dateModulos === 2 ? 'nd' : suffix
            let [month, day] = dateObject.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }).split(' ')

            // 1. Filter sessions by dates
            // 2. Render div.header for each date
            // 3. If date is active, render div.sessions
            // with <MultiDaySession> for each
            let sessions = props.sessions.filter(({ date }) => date === currentDate)
            // TODO: Implement better performance
            let speakerTitles = {}
            props.speakers.map(speaker => speakerTitles[speaker.name] = speaker.title)

            return (<React.Fragment key={index} >
                <div className={`header ${(activeTab === index) ? "active" : ""}`} onClick={() => updateActiveTab(index)}>
                    <span>{`DAY ${index + 1}`}</span>
                    <span className="seperator">: </span>
                    <span className="monthday">{`${month.toUpperCase()}. ${day + suffix.toUpperCase()}`}</span>
                    <div className="caretUp"><img src="https://s3.amazonaws.com/sng-global-web-assets/social/caretup.png" width="20px" /></div>
                    <div className="caretDown"><img src="https://s3.amazonaws.com/sng-global-web-assets/social/caretdown.png" width="15px" /></div>
                </div>

                {(activeTab === index) && sessions && <div className="sessions">
                    {sessions.map((session, key) => {
                        if (session.speakers) {
                            session.speakers.map(speaker => speaker['title'] = speakerTitles[speaker.name])
                        }
                        return <MultiDaySession key={key} {...session} />
                    })}
                </div>}
            </React.Fragment>)
        }
        )}
    </section>
}

const MultiDaySession = props => {
    return <div className="session">
        <div className="time">{props.startTime} - {props.endTime}</div>
        <div className="groupRight">
            <div className="sessiontitle">{props.title}</div>
            {props.speakers && props.speakers.map((speaker, key) => (
                <div className="speaker" key={key}>
                    <span className="name">{speaker.name}, </span>
                    <span className="speakertitle">{speaker.title}</span>
                    {speaker.isModerator && <span>*</span>}
                </div>
            ))}
        </div>
    </div>
}
export default MultiDayAgenda